import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

const DownloadPurchaseBillPdf = (billList, companyName, logo, setOpenBackdrop) => {
    if (!billList || billList.length === 0) {
        alert("No data found to generate report!");
        return;
    }

    const doc = new jsPDF();
    setOpenBackdrop(true);

    try {
        let currentY = 15;
        const pageWidth = doc.internal.pageSize.getWidth();

        // --- Header Section ---
        if (logo) doc.addImage(logo, 'PNG', 14, 8, 12, 12);
        
        doc.setFontSize(10);
        doc.setTextColor(100);
        doc.text(companyName || 'COMPANY NAME', logo ? 28 : 14, 16);
        
        doc.setFontSize(16);
        doc.setTextColor(25, 118, 210);
        doc.setFont("helvetica", "bold");
        const title = 'PURCHASE BILL REPORT';
        doc.text(title, (pageWidth - doc.getTextWidth(title)) / 2, 26);

        doc.setLineWidth(0.5);
        doc.line(14, 30, 196, 30);
        currentY = 40;

        billList.forEach((bill) => {
            if (currentY > 230) { doc.addPage(); currentY = 20; }

            // Bill & Supplier Sub-Header (Height increased to 18 to fit 2 rows)
            doc.setFillColor(240, 244, 248);
            doc.rect(14, currentY, 182, 18, 'F'); 
            doc.setFontSize(9);
            doc.setTextColor(0);
            
            // Row 1: Bill No, Order No, Billing Date
            doc.setFont("helvetica", "bold");
            doc.text(`Bill No: ${bill.purchase_bill_no}`, 18, currentY + 7);
            doc.text(`Order No: ${bill.purchase_order_no || 'N/A'}`, 80, currentY + 7);
            doc.text(`Billing Date: ${bill.billing_date}`, 192, currentY + 7, { align: 'right' });

            // Row 2: Supplier, Due Date
            doc.text(`Supplier: ${bill.suppliers?.contact_name || 'N/A'}`, 18, currentY + 14);
            doc.setTextColor(200, 0, 0); // Due date thoda red/highlighted
            doc.text(`Due Date: ${bill.bill_due_date || 'N/A'}`, 192, currentY + 14, { align: 'right' });
            doc.setTextColor(0);

            currentY += 22; // Padding after header

            // Items Table
            const tableHeaders = [['S.No', 'Item Name', 'Qty', 'Unit', 'Rate', 'Total']];
            const tableData = (bill.items || []).map((item, idx) => [
                idx + 1,
                item.product?.item_name || 'N/A',
                item.quantity,
                item.product?.unit || '',
                Number(item.rate).toFixed(2),
                Number(item.total_amount).toFixed(2)
            ]);

            doc.autoTable({
                startY: currentY,
                head: tableHeaders,
                body: tableData,
                theme: 'grid',
                headStyles: { fillColor: [70, 70, 70], fontSize: 8 },
                styles: { fontSize: 8 },
                columnStyles: { 0: { cellWidth: 10 }, 2: { halign: 'center' }, 4: { halign: 'right' }, 5: { halign: 'right' } },
            });

            currentY = doc.lastAutoTable.finalY + 6;

            // Bill Footer: Challans & Total
            doc.setFontSize(9);
            const challanNos = bill.challans?.map(c => c.challan_no).join(", ") || "N/A";
            doc.setFont("helvetica", "normal");
            doc.setTextColor(100);
            doc.text(`Challans: ${challanNos}`, 14, currentY);

            doc.setFont("helvetica", "bold");
            doc.setTextColor(0);
            doc.text(`Grand Total: Rs. ${Number(bill.total_amount).toFixed(2)}`, 196, currentY, { align: 'right' });

            currentY += 15;
        });

        doc.save(`Purchase_Bills_${new Date().getTime()}.pdf`);
    } catch (error) {
        console.error("PDF Error:", error);
    } finally {
        setOpenBackdrop(false);
    }
};

export default DownloadPurchaseBillPdf;